<div class="box card is-aligned-center is-horizontal is-spaced-between">
    <div class="columns has-gap-1 is-fullwidth is-aligned-center">
        <div class="column is-narrow">
            <span class="icon is-large" [ngClass]="textColor">
                <i [ngClass]="itemIcon"></i>
            </span>
        </div>
        <div class="column">
            <p class="title is-level-5 has-text-weight-bold info-line ml-3">{{ itemLabel }}</p>
        </div>
        <div class="column is-narrow">
            <a [href]="wallUrl" [attr.aria-label]="ctaAriaLabel" class="button is-primary">Choisir</a>
        </div>
    </div>
</div>
